'use strict';

var FlightAnalysisToolbarController = function FlightAnalysisToolbarController($scope, $rootScope, $timeout, searchConst, currentStateCriteriaService, applicableSeasonsLoadingService, featureToggleService, searchCriteriaConstantsService) {
  $scope.screen = searchConst.FLIGHT_ANALYSIS;
  $scope.postDepartureScreen = searchConst.FLIGHT_ANALYSIS_POST_DEPARTURE;
  $scope.searchModes = [];
  if (featureToggleService.isEnabled('REVENUE_OPTIMIZER')) {
    $scope.searchModes.push({
      label: 'Post Departure',
      mode: searchCriteriaConstantsService.SEARCH_MODES.POST_DEPARTURE
    });
  }
  $scope.postDepartureMode = false;
  $scope.switchMode = function (mode) {
    $scope.screen = mode === searchCriteriaConstantsService.SEARCH_MODES.POST_DEPARTURE ? searchConst.FLIGHT_ANALYSIS_POST_DEPARTURE : searchConst.FLIGHT_ANALYSIS;
  };
  $scope.isScenarioManagementToolbarVisible = function () {
    return !($scope.postDepartureMode || $scope.screenState.flightManagementMode.visible) && featureToggleService.isEnabled('REVENUE_OPTIMIZER');
  };
  $scope.isFlightManagementToolbarVisible = function () {
    return $scope.screenState.flightManagementMode.visible;
  };
  $scope.isFlightManagementToggleVisible = function () {
    return !$scope.postDepartureMode && featureToggleService.isEnabled('FLIGHT_MANAGEMENT_VIEW') && featureToggleService.isEnabled('REVENUE_OPTIMIZER');
  };
  $scope.$on('search-criteria:forceSearch', function (evt, scenario) {
    $scope.forcedSearch = true;
    $scope.postDepartureMode = currentStateCriteriaService.isPostDeparture();
    $scope.$broadcast('scenarios:force-select', scenario);
  });
  $scope.triggerSearch = function () {
    if (!$scope.forcedSearch) {
      $scope.$broadcast('scenarios:reset');
    }
    $scope.forcedSearch = false;
    $scope.postDepartureMode = currentStateCriteriaService.isPostDeparture();
    applicableSeasonsLoadingService.resetSeasons();
    $rootScope.$broadcast('screen:onBeforeSearchChangeEvent');
    $timeout(function () {
      $rootScope.$broadcast('search-criteria:searchChangeEvent');
    }, 0);
  };
  $scope.$on('scenarios:load', function () {
    $scope.loadingScenariosInProgress = true;
  });
  $scope.$on('scenarios:loaded', function () {
    $scope.loadingScenariosInProgress = false;
  });
  $scope.globalSave = function () {
    $timeout(function () {
      $rootScope.$broadcast('keyboard:save');
    }, 0);
  };
};
FlightAnalysisToolbarController.$inject = ['$scope', '$rootScope', '$timeout', 'SearchCriteriaConstantsService', 'CurrentStateCriteriaService', 'ApplicableSeasonsLoadingService', 'FeatureToggleService', 'SearchCriteriaConstantsService'];
module.exports = FlightAnalysisToolbarController;